import { Controller } from "stimulus"
import axios from "axios"
import Alerts from "../src/shared/alerts"

const badgeListeners = {}

window.UpdateBadgeCountBus = window.UpdateBadgeCountBus || {
  $on(event, callback) {
    if (!badgeListeners[event]) badgeListeners[event] = []
    badgeListeners[event].push(callback)
  },
  $off(event, callback) {
    if (!badgeListeners[event]) return
    badgeListeners[event] = badgeListeners[event].filter((cb) => cb !== callback)
  },
  $emit(event, ...args) {
    (badgeListeners[event] || []).forEach((cb) => cb(...args))
  }
}

export default class extends Controller {
  static targets = ['badge']

  connect() {
    this.boundHandleBadgeCount = this.handleBadgeCount.bind(this)
    this.boundFetchUnreadMessageCount = this.fetchUnreadMessageCount.bind(this)

    if (window.SOCKET_EVENTS) {
      window.SOCKET_EVENTS.hasChat = true
      window.SOCKET_EVENTS.handleBadgeCount = this.boundHandleBadgeCount
    }

    window.UpdateBadgeCountBus.$on('UPDATE_BADGE', this.boundFetchUnreadMessageCount)
    this.fetchUnreadMessageCount()
  }

  disconnect() {
    if (window.SOCKET_EVENTS && window.SOCKET_EVENTS.handleBadgeCount === this.boundHandleBadgeCount) {
      window.SOCKET_EVENTS.handleBadgeCount = () => null
    }
    window.UpdateBadgeCountBus.$off('UPDATE_BADGE', this.boundFetchUnreadMessageCount)
  }

  handleBadgeCount({ message, conversation_id }) {
    const isChat = window.location.href.indexOf('chat') !== -1
    const isSender = this.currentUserId === message.sender.id

    if (!isChat && !isSender) {
      this.fetchUnreadMessageCount()
      Alerts.newMessage(message, conversation_id)
    }
  }

  async fetchUnreadMessageCount() {
    try {
      const response = await axios.get('/api/v1/user_unread_message_count', {
        params: {
          subdomain: this.subdomain,
          auth_token: this.authToken,
          id: this.currentUserId
        }
      })
      this.updateBadge(response.data)
    } catch (e) {
      console.error(e)
    }
  }

  updateBadge(count) {
    if (!this.hasBadgeTarget) return

    const countNumber = Number(count) || 0
    this.badgeTarget.textContent = countNumber
    this.badgeTarget.classList.toggle('d-none', countNumber < 1)
  }

  get subdomain() {
    return this.element.dataset.subdomain
  }

  get authToken() {
    return this.element.dataset.authToken
  }

  get currentUserId() {
    return this.element.dataset.currentUserId
  }
}
